<div class="signer-items-wrapper">
  <div *ngFor="let item of data" class="signer-item" [matTooltip]="item.role">
    {{ getInitials | call : item.role }}
  </div>
</div>

<div class="signer-items-addition mt-3" *ngIf="data.length > 1">
  <div i18n class="description">Sign in any order</div>
</div>
